// @ts-nocheck
/*
 * Edit Agent — v1 logic preserved end-to-end (extension dropdown gates,
 * telephony profile country-code hydration, password/type/country-code/
 * WEBRTC cli-option validation, sessionStorage 'agentsReturnTo' redirect,
 * ACL-gated toggles, call-centre-admin AgentAccountSettingsSection).
 *
 * Chrome swap: react-bootstrap Row/Col/Card/Form.* → shadcn Card + native
 * <select>/<input>/<radio> with the existing form-control CSS class (kept
 * because the icon-overlay layout depends on it). react-select and
 * AgentAccountSettingsSection stay as-is (existing v2 components).
 */
import {
  AvailabilityHint,
  useAgentNameAvailability,
  useAgentNumberAvailability,
  useAgentEmailAvailability,
} from '@/hooks/useAvailability';
import { useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'sonner';
import { friendlyApiError } from '@/utilities/apiErrorMessage';
import {
  FaArrowLeft,
  FaCog,
  FaEnvelope,
  FaFileAlt,
  FaGlobe,
  FaInfoCircle,
  FaLightbulb,
  FaLock,
  FaMobileAlt,
  FaPhoneAlt,
  FaPlusCircle,
  FaPuzzlePiece,
  FaRegUser,
  FaShieldAlt,
  FaUser,
} from 'react-icons/fa';
import { postApiCall } from '@/service/postApiCall';
import { getApiCall } from '@/service/getApiCall';
import {
  API_AGENT_UPDATE,
  API_AGENTS_LIST,
  API_AGENT_GROUP_EXTENSION,
  API_USER_COUNTRY_CODE_DIRECTIONS_ME,
  API_USER_COUNTRY_CODE_DIRECTIONS_BY_AGENT,
  API_CALL_CENTRE_PROFILE,
} from '@/service/url';
import CountryCodeDirectionPicker from '@/components/partials/dashboard/country-code-direction/CountryCodeDirectionPicker';
import { validateEmail, sortExtensionsAscending, getAgentNameFieldError } from '@/utilities/helpers';
import { MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT, USER_ROLES } from '@/utilities/constant';
import { fetchAndSetFlashMessage } from '@/service/fetchFlashMessage';
import { Storage } from '@/utilities/setting';
import {
  canEditAgentOption,
  getAllowedAgentTypeSelectOptions,
  getUserModuleOperations,
} from '@/utilities/agentAcl';
import AgentAccountSettingsSection from '@/components/partials/dashboard/manage-agents/AgentAccountSettingsSection';
import { appendAgentAccountFields } from '@/utilities/agentAccountSettingsHelpers';
import {
  canManageChildVoicemail,
  getAssignedCallCentreId,
  readVoicemailEnabled,
} from '@/utilities/callCentreVoicemailAcl';
import {
  canManageChildTranscription,
  readTranscriptionEnabled,
} from '@/utilities/callCentreTranscriptionAcl';
import { formatAgentUniqueConflictMessage } from '@/utilities/agentCountryCode';
import { Card, CardContent } from '@/components/ui/card';
import { ScrollPage } from '@/components/layout/PageContainer';
import { Stepper, useStepper } from '@/components/ui/stepper';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

export default function EditAgent() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [agentName, setAgentName] = useState('');
  const [agentNumber, setAgentNumber] = useState('');
  const [selectedExtension, setSelectedExtension] = useState<any>(null);
  const [emailId, setEmailId] = useState('');
  const [description, setDescription] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [access, setAccess] = useState<any>(null);
  const [type, setType] = useState<any[]>([]);
  const [loginStatus, setLoginStatus] = useState('');
  const [, setAgentAllocatedExtension] = useState<any>(null);
  const [allExtensions, setAllExtensions] = useState<any[]>([]);

  const [extensionOptions, setExtensionOptions] = useState<any[]>([]);
  const [, setShowToast] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [agentNameError, setAgentNameError] = useState('');
  const [originalAgentName, setOriginalAgentName] = useState('');
  const [originalAgentNumber, setOriginalAgentNumber] = useState('');
  const [originalAgentEmail, setOriginalAgentEmail] = useState('');

 
  const agentNameStatus = useAgentNameAvailability(agentName, {
    enabled: Boolean(originalAgentName) && agentName.trim().length > 0,
    originalValue: originalAgentName,
    excludeId: id ?? null,
  });
  const agentNumberStatus = useAgentNumberAvailability(String(agentNumber ?? ''), {
    enabled: Boolean(originalAgentNumber) && String(agentNumber ?? '').trim().length > 0,
    originalValue: originalAgentNumber,
    excludeId: id ?? null,
  });
  const agentEmailStatus = useAgentEmailAvailability(emailId, {
    enabled: Boolean(originalAgentEmail) && emailId.trim().length > 0 && !validateEmail(emailId),
    originalValue: originalAgentEmail,
    excludeId: id ?? null,
  });
  const [usernameError, setUsernameError] = useState('');
  const existingAgentNamesRef = useRef(new Set());
  const [existingNamesTick, setExistingNamesTick] = useState(0);
  const [notes, setNotes] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const submittingRef = useRef(false);
  const [showPassword, setShowPassword] = useState(false);

  const [countryCode, setCountryCode] = useState('');
  const [countryCodeError, setCountryCodeError] = useState('');
  const [cliOption, setCliOption] = useState('actual');
  const [isOutboundEnabled, setIsOutboundEnabled] = useState(false);
  const [firstCallAcceptance, setFirstCallAcceptance] = useState('agent');
  const [voicemailEnabled, setVoicemailEnabled] = useState(false);
  const [transcriptionEnabled, setTranscriptionEnabled] = useState(false);
  const [maskingEnabled, setMaskingEnabled] = useState(false);
  const [callCentreProfile, setCallCentreProfile] = useState<any>(null);
  const [passwordError, setPasswordError] = useState('');
  const [availableCcDirections, setAvailableCcDirections] = useState<any[]>([]);
  const [selectedCcDirections, setSelectedCcDirections] = useState<any[]>([]);

  const [selectedACL, setSelectedACL] = useState('');
  const [accountType, setAccountType] = useState('0');
  const [expiryDate, setExpiryDate] = useState('');
  const [parentAccountType, setParentAccountType] = useState('0');
  const [parentExpiryDate, setParentExpiryDate] = useState<any>(null);

  const accessOptions = [
    { label: 'Regular', value: 'regular' },
    { label: 'Team Lead', value: 'team_lead' },
  ];
  const firstCallAcceptanceOptions = [
    { label: 'Agent', value: 'agent' },
    { label: 'Customer', value: 'customer' },
  ];

  const agentAclContext = useMemo(() => {
    try {
      const raw = Storage.getItem('user');
      const user = raw ? JSON.parse(raw) : null;
      return { userRole: user?.role, isSuperAdmin: user?.role === USER_ROLES.SUPERADMIN };
    } catch {
      return { userRole: null, isSuperAdmin: false };
    }
  }, []);

  const userModuleOps = useMemo(() => {
    try {
      const raw = Storage.getItem('user');
      const user = raw ? JSON.parse(raw) : null;
      return getUserModuleOperations(user);
    } catch {
      return {};
    }
  }, []);

  const typeOptions = useMemo(
    () => getAllowedAgentTypeSelectOptions(userModuleOps, agentAclContext),
    [userModuleOps, agentAclContext],
  );

  const isDemoCompanyAgent = useMemo(() => {
    try {
      const user = JSON.parse(Storage.getItem('user') || 'null');
      const company = user?.assignedCompany || user?.assigned_company_details || user?.company || null;
      return company?.is_demo_company === true;
    } catch {
      return false;
    }
  }, []);

  const canOutboundEnabled = useMemo(
    () => canEditAgentOption(userModuleOps, 'outbound_enabled', agentAclContext),
    [userModuleOps, agentAclContext],
  );
  const canFirstCallConnect = useMemo(
    () => canEditAgentOption(userModuleOps, 'first_call_connect', agentAclContext),
    [userModuleOps, agentAclContext],
  );
  const canVoicemailEnabled = useMemo(
    () => canManageChildVoicemail(callCentreProfile),
    [callCentreProfile],
  );
  const canTranscriptionEnabled = useMemo(
    () => canManageChildTranscription(callCentreProfile),
    [callCentreProfile],
  );

  const isCallCentreAdmin = agentAclContext.userRole === USER_ROLES.CALL_CENTRE_ADMIN;

  useEffect(() => {
    if (!isCallCentreAdmin) return;
    try {
      const raw = Storage.getItem('user');
      const user = raw ? JSON.parse(raw) : null;
      if (user?.account_type !== undefined && user?.account_type !== null) {
        setParentAccountType(String(user.account_type));
      }
      if (user?.expiry_date) setParentExpiryDate(user.expiry_date);
    } catch {
      /* ignore */
    }
  }, [isCallCentreAdmin]);

  useEffect(() => {
    getApiCall(`${API_AGENT_GROUP_EXTENSION}?data=all`)
      .then((data: any) => {
        const list = sortExtensionsAscending(Array.isArray(data) ? data : []);
        setAllExtensions(list);
        const availableExtensions = list.filter((ext) => ext.is_allocated == 0);
        const formatted = availableExtensions.map((ext) => ({ label: ext.username, value: ext.id }));
        setExtensionOptions([{ label: 'Select Extension', value: null }, ...formatted]);
      })
      .catch(() => {
        toast.error('Error fetching extensions.');
        setShowToast(true);
      });

    getApiCall(API_AGENTS_LIST, { fields: 'min' })
      .then((resp: any) => {
        const list = Array.isArray(resp) ? resp : [];
        const names = new Set();
        const excludeId = id ? String(id) : null;
        list.forEach((a) => {
          if (excludeId && String(a.id) === excludeId) return;
          const n = String(a?.agent_name || '').trim().toLowerCase();
          if (n) names.add(n);
        });
        existingAgentNamesRef.current = names;
        setExistingNamesTick((t) => t + 1);
      })
      .catch(() => {});

    fetchAndSetFlashMessage(
      (msg) =>
        msg.module_name === MODULE_ACL.AGENTS &&
        msg.action === FLASH_MESSAGE_ACTION_OBJECT.EDIT &&
        msg.type === 'Note',
      setNotes,
    );

    getApiCall(API_USER_COUNTRY_CODE_DIRECTIONS_ME, {})
      .then((data: any) => {
        const list = (Array.isArray(data) ? data : []).map((row) => row.directionMaster).filter(Boolean);
        setAvailableCcDirections(list);
      })
      .catch(() => setAvailableCcDirections([]));

    if (id) {
      getApiCall(API_USER_COUNTRY_CODE_DIRECTIONS_BY_AGENT(id), {})
        .then((data: any) => {
          const ids = (Array.isArray(data) ? data : [])
            .map((row) => row.country_code_direction_id)
            .filter(Boolean);
          setSelectedCcDirections(ids);
        })
        .catch(() => {});
    }

    try {
      const raw = Storage.getItem('user');
      const user = raw ? JSON.parse(raw) : null;
      const ccId = getAssignedCallCentreId(user);
      if (ccId) {
        getApiCall(API_CALL_CENTRE_PROFILE.replace(':id', ccId))
          .then((resp) => setCallCentreProfile(resp))
          .catch(() => setCallCentreProfile(null));
      } else {
        setCallCentreProfile(null);
      }
    } catch {
      setCallCentreProfile(null);
    }
  }, []);

  useEffect(() => {
    getApiCall(`${API_AGENT_UPDATE}/${id}`)
      .then((data: any) => {
        setAccess(data.access);
        setAgentName(data.agent_name);
        setAgentNumber(data.agent_number);
        setOriginalAgentName(String(data.agent_name ?? ''));
        setOriginalAgentNumber(String(data.agent_number ?? ''));
        setDescription(data.description);
        setEmailId(data.email_id);
        setOriginalAgentEmail(String(data.email_id ?? ''));
        setType(data.type || []);
        setCliOption(data.cli_option || 'actual');
        setIsOutboundEnabled(data.is_outbound_enabled === true);
        setFirstCallAcceptance(data.first_call_acceptance || 'agent');
        setVoicemailEnabled(readVoicemailEnabled(data));
        setTranscriptionEnabled(readTranscriptionEnabled(data));
        setMaskingEnabled(data.is_masking_enabled === true);

        const mobileProfile = data?.telephonyProfile?.profile?.find((p) => p.type === 'Mobile');
        const cc = mobileProfile?.number?.country_code || '';
        setCountryCode(cc);

        setSelectedExtension(data.extensionId);
        if (data.extensionName) {
          setAgentAllocatedExtension(data.extensionName);
          const currentExtension = allExtensions.find((ext) => ext.id === data.extensionId);
          if (currentExtension) {
            setExtensionOptions((prev) => [
              { label: 'Select Extension', value: null },
              { label: currentExtension.username, value: currentExtension.id },
              ...prev.filter((opt) => opt.value !== currentExtension.id && opt.value !== null),
            ]);
          }
        }
        setUsername(data.username);
        setLoginStatus(data.login_status);
        if (data.acl_settings_id) setSelectedACL(String(data.acl_settings_id));
        if (data.account_type !== undefined && data.account_type !== null) {
          setAccountType(String(data.account_type));
        }
        if (data.expiry_date) {
          const ed = new Date(data.expiry_date);
          const ey = ed.getFullYear();
          const em = String(ed.getMonth() + 1).padStart(2, '0');
          const eday = String(ed.getDate()).padStart(2, '0');
          setExpiryDate(`${ey}-${em}-${eday}`);
        }
      })
      .catch(() => {
        toast.error('Error fetching Agents.');
        setShowToast(true);
      });
  }, [allExtensions]);

  useEffect(() => {
    if (!agentName) return;
    const msg = getAgentNameFieldError(agentName, existingAgentNamesRef.current);
    setAgentNameError(msg);
  }, [existingNamesTick]);

  const validateAgentName = (value) => {
    const msg = getAgentNameFieldError(value, existingAgentNamesRef.current);
    setAgentNameError(msg);
    return !msg;
  };

  const validateUsername = (value) => {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      setUsernameError('Username is required');
      return false;
    }
    const usernameRegex = /^[a-zA-Z0-9_]+$/;
    if (!usernameRegex.test(trimmedValue)) {
      setUsernameError(
        'Username can only contain letters, numbers, and underscores (_). No spaces or special characters allowed.',
      );
      return false;
    }
    setUsernameError('');
    return true;
  };

  const validatePassword = (value) => {
    const isValid =
      value.length >= 8 &&
      /[A-Z]/.test(value) &&
      /[a-z]/.test(value) &&
      /[0-9]/.test(value) &&
      /[!@#$%^&*(),.?":{}|<>_\-\\[\]\/+=~`]/.test(value) &&
      !/\s/.test(value);
    if (value && !isValid) {
      setPasswordError('Password must meet all requirements');
      return false;
    }
    setPasswordError('');
    return true;
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    validatePassword(value);
  };

  const handleEditAgent = async () => {
    if (loading || submittingRef.current) return;
    if (agentNameStatus === 'taken') {
      toast.error('Agent name already exists');
      return;
    }
    if (agentNumberStatus === 'taken') {
      toast.error('Agent number already exists');
      return;
    }
    if (emailError) {
      toast.error('Enter correct Email.');
      return;
    }
    if (agentEmailStatus === 'taken') {
      toast.error('Email already exists');
      return;
    }
    const nameErr = getAgentNameFieldError(agentName, existingAgentNamesRef.current);
    if (nameErr) {
      setAgentNameError(nameErr);
      toast.error(nameErr);
      return;
    }
    if (!validateUsername(username)) {
      toast.error(usernameError || 'Username validation failed');
      return;
    }

    let filteredType = type;
    if (!selectedExtension) filteredType = type.filter((t) => t != 'Soft Phone' && t != 'WEBRTC');
    if (!filteredType || filteredType?.length < 1) {
      toast.error('Type required');
      return;
    }
    if (!typeOptions.length) {
      toast.error('Your ACL does not allow any agent types (Mobile / Soft Phone / WEBRTC).');
      return;
    }

    if (filteredType.includes('Mobile')) {
      if (!validateCountryCode(countryCode)) {
        toast.error(countryCodeError || 'Invalid country code');
        return;
      }
    }
    if (filteredType.includes('WEBRTC')) {
      if (!cliOption) {
        toast.error('Select incoming call display option');
        return;
      }
    }
    if (password && !validatePassword(password)) {
      toast.error('Password must meet all requirements');
      return;
    }
    if (isCallCentreAdmin) {
      if (!expiryDate && !isDemoCompanyAgent) {
        toast.error('Account expiry date is required');
        return;
      }
    }

    const payload: any = {
      agent_name: agentName,
      agent_number: String(agentNumber),
      email_id: emailId,
      description,
      access,
      type: filteredType,
      login_status: loginStatus,
      country_code: filteredType.includes('Mobile') ? countryCode : null,
      cli_option: filteredType.includes('WEBRTC') ? cliOption : null,
      is_outbound_enabled: !!isOutboundEnabled,
      is_masking_enabled: !!maskingEnabled,
      first_call_acceptance: filteredType.includes('Mobile') ? firstCallAcceptance || 'agent' : 'agent',
      country_code_directions: Array.isArray(selectedCcDirections) ? selectedCcDirections.map(Number) : [],
    };

    if (canOutboundEnabled) payload.is_outbound_enabled = !!isOutboundEnabled;
    if (canFirstCallConnect) {
      payload.first_call_acceptance = filteredType.includes('Mobile') ? firstCallAcceptance || 'agent' : 'agent';
    }
    if (canVoicemailEnabled) payload.is_voicemail_enabled = !!voicemailEnabled;
    if (canTranscriptionEnabled) payload.is_transcription_enabled = !!transcriptionEnabled;

    if (password) payload.password = password;

    submittingRef.current = true;
    setLoading(true);

    if (isCallCentreAdmin) {
      appendAgentAccountFields(payload, { selectedACL, accountType, expiryDate });
    }

    if (Array.isArray(type) && !(type.includes('Soft Phone') || type.includes('WEBRTC')) && selectedExtension) {
      toast.error('Extension will be allocated only in case of Type Soft Phone or Type Webrtc.');
      submittingRef.current = false;
      setLoading(false);
      return;
    }
    if (selectedExtension && ((Array.isArray(type) && type.includes('Soft Phone')) || type.includes('WEBRTC'))) {
      payload.extension = selectedExtension;
    }

    try {
      setLoading(true);
      await postApiCall(`${API_AGENT_UPDATE}/${id}`, payload);
      toast.success('Agent Updated Successfully');
      setShowToast(true);
      const returnTo = sessionStorage.getItem('agentsReturnTo') || '/agents';
      setTimeout(() => navigate(returnTo.startsWith('/') ? returnTo : `/${returnTo}`), 2000);
    } catch (err: any) {
      const msg =
        typeof err === 'string' ? err : err?.response?.data?.message || err?.message || String(err);
      toast.error(formatAgentUniqueConflictMessage(friendlyApiError(err) || msg));
      setShowToast(true);
    } finally {
      setLoading(false);
      submittingRef.current = false;
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmailId(value);
    setEmailError(validateEmail(value));
  };

  const validateCountryCode = (value) => {
    if (!value) {
      setCountryCodeError('Country code is required');
      return false;
    }
    if (!/^\d{1,4}$/.test(value)) {
      setCountryCodeError('Only numbers allowed (1–4 digits)');
      return false;
    }
    setCountryCodeError('');
    return true;
  };

  const requiredMark = <span className="ml-1 text-destructive">*</span>;
  const cardStyle: any = {
    border: '1px solid hsl(var(--border) / 0.6)',
    borderRadius: 12,
    background: 'hsl(var(--card))',
    color: 'hsl(var(--foreground))',
    boxShadow:
      '6px 6px 14px rgba(163, 177, 198, 0.35), -6px -6px 14px rgba(255, 255, 255, 0.9)',
  };
  const labelStyle: any = {
    marginBottom: 8,
    color: 'hsl(var(--foreground))',
    fontWeight: 500,
  };
  const inputStyle: any = {
    minHeight: 40,
    border: '1px solid hsl(var(--border) / 0.6)',
    borderRadius: 6,
    fontSize: 13,
    background: 'hsl(var(--card))',
    color: 'hsl(var(--foreground))',
    boxShadow:
      'inset 2px 2px 5px rgba(163, 177, 198, 0.35), inset -2px -2px 5px rgba(255, 255, 255, 0.9)',
  };
  const iconInputStyle: any = { ...inputStyle, paddingLeft: 39 };
  const inputWrapperStyle: any = { position: 'relative' };
  const inputIconStyle: any = {
    position: 'absolute',
    left: 14,
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'hsl(var(--primary))',
    fontSize: 13,
    zIndex: 2,
    pointerEvents: 'none',
  };
  const noteText =
    notes.find((n) => Number(n.priority) === 1)?.message ||
    'Extension will be allocated only in case of Type Soft Phone or Type Webrtc.';

  // Keep currently assigned types visible even if ACL no longer grants them (edit grandfathering).
  const typeSelectOptions = useMemo(() => {
    const base = !selectedExtension
      ? typeOptions.filter((o) => o.value === 'Mobile')
      : typeOptions;
    const merged = [...base];
    for (const t of type) {
      if (!merged.some((o) => o.value === t)) {
        merged.push({ label: t, value: t });
      }
    }
    return merged;
  }, [selectedExtension, typeOptions, type]);

  const stepDescriptors = [
    {
      id: 'basic',
      label: 'Basic Information',
      description: 'Identity & credentials',
      icon: FaRegUser as any,
    },
    {
      id: 'settings',
      label: 'Settings & Description',
      description: 'Preferences and notes',
      icon: FaCog as any,
    },
    ...(isCallCentreAdmin
      ? [
          {
            id: 'account',
            label: 'Account Settings',
            description: 'ACL and expiry',
            icon: FaShieldAlt as any,
          },
        ]
      : []),
  ];
  const stepper = useStepper(stepDescriptors.length, 0);

  return (
    <ScrollPage>
      <div className="mx-auto max-w-6xl px-1 py-1">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="mb-4 flex items-center gap-3">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-border/60 bg-card text-foreground shadow-[3px_3px_6px_rgba(163,177,198,0.35),-3px_-3px_6px_rgba(255,255,255,0.9)] transition-colors hover:bg-accent hover:text-accent-foreground cursor-pointer"
            aria-label="Go back"
            title="Go back"
          >
            <FaArrowLeft size={13} />
          </button>
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <FaUser size={18} />
            </span>
            <div>
              <h4 className="m-0 text-lg font-bold text-foreground">Edit Agent</h4>
              <p className="m-0 text-xs text-muted-foreground">
                Update agent details in your system.
              </p>
            </div>
          </div>
        </div>

        <div
          className="mb-3 flex items-start gap-2 rounded-lg border border-primary/25 bg-primary/[0.06] px-3 py-2 text-xs text-foreground"
          role="alert"
        >
          <FaInfoCircle size={15} className="mt-0.5 shrink-0 text-primary" />
          <span>
            <strong>Note:</strong> {noteText}
          </span>
        </div>

        <div
          className="mb-4 rounded-xl border border-border/60 bg-card px-5 py-4"
          style={{
            boxShadow:
              '6px 6px 14px rgba(163, 177, 198, 0.35), -6px -6px 14px rgba(255, 255, 255, 0.9)',
          }}
        >
          <Stepper
            steps={stepDescriptors}
            current={stepper.current}
            completed={stepper.completed}
            onStepClick={stepper.goTo}
          />
        </div>

        {stepper.current === 0 && (
        <Card style={cardStyle} className="mb-3">
          <CardContent style={{ padding: 20 }}>
            <div className="d-flex align-items-start gap-2 mb-4">
              <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <FaRegUser size={14} />
              </span>
              <div>
                <p className="m-0 text-sm font-bold text-foreground">Basic Information</p>
                <p className="m-0 text-xs text-muted-foreground">Enter the primary details of the agent.</p>
              </div>
            </div>

            <div className="row g-4">
              <div className="col-md-4">
                <label htmlFor="agentName" className="mb-1.5 block text-xs font-semibold text-foreground" style={labelStyle}>
                  Agent Name {requiredMark}
                </label>
                <div style={inputWrapperStyle}>
                  <FaRegUser style={inputIconStyle} />
                  <input
                    type="text"
                    id="agentName"
                    value={agentName}
                    onChange={(e) => {
                      const value = e.target.value;
                      setAgentName(value);
                      validateAgentName(value);
                    }}
                    onBlur={(e) => validateAgentName(e.target.value)}
                    className={`form-control ${agentNameError ? 'is-invalid' : ''}`}
                    placeholder="Enter agent name"
                    required
                    style={iconInputStyle}
                  />
                </div>
                {agentNameError && <div className="invalid-feedback d-block">{agentNameError}</div>}
                {!agentNameError && (
                  <AvailabilityHint status={agentNameStatus} takenMessage="Agent name already exists" />
                )}
              </div>

              <div className="col-md-4">
                <label htmlFor="agentNumber" className="mb-1.5 block text-xs font-semibold text-foreground" style={labelStyle}>
                  Agent Number {requiredMark}
                </label>
                <div style={inputWrapperStyle}>
                  <FaPhoneAlt style={inputIconStyle} />
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength={10}
                    id="agentNumber"
                    value={agentNumber}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d{0,10}$/.test(val)) setAgentNumber(val);
                    }}
                    className={`form-control ${agentNumberStatus === 'taken' ? 'is-invalid' : ''}`}
                    placeholder="Enter agent number"
                    required
                    style={iconInputStyle}
                  />
                </div>
                <AvailabilityHint status={agentNumberStatus} takenMessage="Agent number already exists" />
              </div>

              <div className="col-md-4">
                <label htmlFor="emailId" className="mb-1.5 block text-xs font-semibold text-foreground" style={labelStyle}>
                  Email ID {requiredMark}
                </label>
                <div style={inputWrapperStyle}>
                  <FaEnvelope style={inputIconStyle} />
                  <input
                    type="email"
                    id="emailId"
                    value={emailId}
                    onChange={handleEmailChange}
                    className="form-control"
                    placeholder="Enter email address"
                    required
                    style={iconInputStyle}
                  />
                </div>
                {emailError && <span className="text-danger">{emailError}</span>}
                {!emailError && <AvailabilityHint status={agentEmailStatus} takenMessage="Email already exists" />}
              </div>

              <div className="col-md-4">
                <label htmlFor="extensionDropdown" className="mb-1.5 block text-xs font-semibold text-foreground" style={labelStyle}>
                  Extension
                </label>
                <div style={inputWrapperStyle}>
                  <FaPuzzlePiece style={inputIconStyle} />
                  <select
                    id="extensionDropdown"
                    value={selectedExtension || ''}
                    onChange={(e) => {
                      const value = e.target.value || null;
                      setSelectedExtension(value);
                      if (!value) {
                        setType((prev) => prev.filter((t) => t !== 'Soft Phone' && t !== 'WEBRTC'));
                      }
                    }}
                    className="form-control form-select"
                    style={iconInputStyle}
                  >
                    {extensionOptions.map((ext) => (
                      <option key={ext.value} value={ext.value ?? ''}>
                        {ext.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-md-4">
                <label htmlFor="username" className="mb-1.5 block text-xs font-semibold text-foreground" style={labelStyle}>
                  Username {requiredMark}
                </label>
                <div style={{ ...inputWrapperStyle, pointerEvents: 'none' }}>
                  <FaUser style={{ ...inputIconStyle, opacity: 0.55 }} />
                  <input
                    type="text"
                    id="username"
                    autoComplete="off"
                    value={username}
                    readOnly
                    disabled
                    tabIndex={-1}
                    className="form-control agent-form-readonly"
                    placeholder="Username"
                    style={iconInputStyle}
                  />
                </div>
              </div>

              <div className="col-md-4">
                <label htmlFor="password" className="mb-1.5 block text-xs font-semibold text-foreground" style={labelStyle}>
                  Password
                </label>
                <div style={inputWrapperStyle}>
                  <FaLock style={inputIconStyle} />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    value={password}
                    autoComplete="off"
                    readOnly
                    onFocus={(e: any) => e.target.removeAttribute('readOnly')}
                    onChange={handlePasswordChange}
                    className={`form-control ${passwordError ? 'is-invalid' : ''}`}
                    placeholder="Enter new password"
                    style={{ ...iconInputStyle, paddingRight: 42 }}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: 14,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      color: '#64748b',
                      fontSize: 15,
                    }}
                  >
                    {showPassword ? (
                      <i className="fa-solid fa-eye-slash" />
                    ) : (
                      <i className="fa-solid fa-eye" />
                    )}
                  </span>
                </div>
                {passwordError && (
                  <div className="text-danger" style={{ fontSize: 13, marginTop: 5 }}>
                    {passwordError}
                  </div>
                )}
              </div>

              <div className="col-md-4">
                <label htmlFor="accessDropdown" className="mb-1.5 block text-xs font-semibold text-foreground" style={labelStyle}>
                  Access {requiredMark}
                </label>
                <div style={inputWrapperStyle}>
                  <FaShieldAlt style={inputIconStyle} />
                  <select
                    id="accessDropdown"
                    value={access || ''}
                    onChange={(e) => setAccess(e.target.value)}
                    className="form-control form-select"
                    style={iconInputStyle}
                  >
                    <option value="">Select access</option>
                    {accessOptions.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-md-4">
                <label htmlFor="typeDropdown" className="mb-1.5 block text-xs font-semibold text-foreground" style={labelStyle}>
                  Type {requiredMark}
                </label>
                <div style={inputWrapperStyle}>
                  <FaMobileAlt style={inputIconStyle} />
                  <Select
                    isMulti
                    inputId="typeDropdown"
                    value={type.map((v) => ({ label: v, value: v }))}
                    options={typeSelectOptions}
                    onChange={(selected: any) => {
                      let newValue = (selected || []).map((o) => o.value);
                      if (!selectedExtension) newValue = newValue.filter((t) => t === 'Mobile');
                      setType(newValue);
                    }}
                    placeholder="Select type"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: 41,
                        border: '1px solid #dbe3ef',
                        borderRadius: 6,
                        paddingLeft: 30,
                        fontSize: 12,
                        boxShadow: 'none',
                      }),
                      menu: (base) => ({ ...base, zIndex: 5 }),
                    }}
                    menuPlacement="auto"
                    className="theme-react-select"
                    classNamePrefix="theme-react-select"
                  />
                </div>
              </div>
            </div>

            {type.includes('Mobile') && (
              <div className="row g-4 mt-1">
                <div className="col-md-4">
                  <label className="mb-1.5 block text-xs font-semibold text-foreground" style={labelStyle}>
                    Country Code (Mobile) {requiredMark}
                  </label>
                  <div style={inputWrapperStyle}>
                    <FaGlobe style={inputIconStyle} />
                    <input
                      type="text"
                      inputMode="numeric"
                      maxLength={4}
                      value={countryCode}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d{0,4}$/.test(val)) {
                          setCountryCode(val);
                          validateCountryCode(val);
                        }
                      }}
                      className={`form-control ${countryCodeError ? 'is-invalid' : ''}`}
                      placeholder="e.g. 91"
                      style={iconInputStyle}
                    />
                  </div>
                  {countryCodeError && <div className="invalid-feedback">{countryCodeError}</div>}
                </div>
              </div>
            )}

            {type.includes('WEBRTC') && (
              <div className="row g-4 mt-1">
                <div className="col-md-8">
                  <label className="mb-1.5 block text-xs font-semibold text-foreground" style={labelStyle}>
                    Incoming Call Display (WEBRTC Only) {requiredMark}
                  </label>
                  <div className="d-flex flex-wrap gap-3" style={{ marginTop: 6, fontSize: 12 }}>
                    <label className="d-inline-flex align-items-center gap-1">
                      <input
                        type="radio"
                        name="cliOption"
                        value="actual"
                        checked={cliOption === 'actual'}
                        onChange={(e) => setCliOption(e.target.value)}
                      />
                      Show Actual Number
                    </label>
                    <label className="d-inline-flex align-items-center gap-1">
                      <input
                        type="radio"
                        name="cliOption"
                        value="virtual"
                        checked={cliOption === 'virtual'}
                        onChange={(e) => setCliOption(e.target.value)}
                      />
                      Show Virtual Number (Assigned CLI)
                    </label>
                  </div>
                </div>
              </div>
            )}
          </CardContent>
        </Card>
        )}

        {stepper.current === 1 && (
        <div className="flex flex-col gap-3">
          <div>
            <Card style={cardStyle}>
              <CardContent style={{ padding: 20 }}>
                <div className="d-flex align-items-start gap-2 mb-4">
                  <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <FaCog size={14} />
                  </span>
                  <div>
                    <p className="m-0 text-sm font-bold text-foreground">Settings</p>
                    <p className="m-0 text-xs text-muted-foreground">Configure additional settings for the agent.</p>
                  </div>
                </div>

                <div className="row g-3">
                  {canVoicemailEnabled ? (
                    <div className="col-md-4">
                      <div className="d-flex align-items-center gap-1 mb-2">
                        <label className="form-label agent-form-label mb-0" style={labelStyle}>
                          Voicemail Enabled
                        </label>
                        <FaInfoCircle size={11} style={{ color: '#94a3b8' }} />
                      </div>
                      <div className="form-check form-switch" style={{ paddingTop: 2 }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="voicemailEnabledEdit"
                          checked={!!voicemailEnabled}
                          onChange={(e) => setVoicemailEnabled(e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="voicemailEnabledEdit"
                          style={{ marginLeft: 8, fontSize: 12 }}
                        >
                          {voicemailEnabled ? 'Enabled' : 'Disabled'}
                        </label>
                      </div>
                    </div>
                  ) : null}
                  {canTranscriptionEnabled ? (
                    <div className="col-md-4">
                      <div className="d-flex align-items-center gap-1 mb-2">
                        <label className="form-label agent-form-label mb-0" style={labelStyle}>
                          Transcription Enabled
                        </label>
                        <FaInfoCircle size={11} style={{ color: '#94a3b8' }} />
                      </div>
                      <div className="form-check form-switch" style={{ paddingTop: 2 }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="transcriptionEnabledEdit"
                          checked={!!transcriptionEnabled}
                          onChange={(e) => setTranscriptionEnabled(e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="transcriptionEnabledEdit"
                          style={{ marginLeft: 8, fontSize: 12 }}
                        >
                          {transcriptionEnabled ? 'Enabled' : 'Disabled'}
                        </label>
                      </div>
                    </div>
                  ) : null}
                  {canOutboundEnabled ? (
                    <div className="col-md-4">
                      <div className="d-flex align-items-center gap-1 mb-2">
                        <label className="form-label agent-form-label mb-0" style={labelStyle}>
                          Outbound Enabled
                        </label>
                        <FaInfoCircle size={11} style={{ color: '#94a3b8' }} />
                      </div>
                      <div className="form-check form-switch" style={{ paddingTop: 2 }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="isOutboundEnabledEdit"
                          checked={!!isOutboundEnabled}
                          onChange={(e) => setIsOutboundEnabled(e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="isOutboundEnabledEdit"
                          style={{ marginLeft: 8, fontSize: 12 }}
                        >
                          {isOutboundEnabled ? 'Enabled' : 'Disabled'}
                        </label>
                      </div>
                    </div>
                  ) : null}
                  <div className="col-md-4">
                    <div className="d-flex align-items-center gap-1 mb-2">
                      <label className="form-label agent-form-label mb-0" style={labelStyle}>
                        Number Masking
                      </label>
                      <FaInfoCircle size={11} style={{ color: '#94a3b8' }} />
                    </div>
                    <div className="form-check form-switch" style={{ paddingTop: 2 }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="maskingEnabledEdit"
                        checked={!!maskingEnabled}
                        onChange={(e) => setMaskingEnabled(e.target.checked)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="maskingEnabledEdit"
                        style={{ marginLeft: 8, fontSize: 12 }}
                      >
                        {maskingEnabled ? 'Enabled' : 'Disabled'}
                      </label>
                    </div>
                  </div>
                  {type.includes('Mobile') && (
                    <div className="col-md-4">
                      <div className="d-flex align-items-center gap-1 mb-2">
                        <label
                          htmlFor="firstCallAcceptance"
                          className="form-label agent-form-label mb-0"
                          style={labelStyle}
                        >
                          First Call Connect (MOBILE Only)
                        </label>
                        <FaInfoCircle size={11} style={{ color: '#94a3b8' }} />
                      </div>
                      <div style={inputWrapperStyle}>
                        <FaUser style={inputIconStyle} />
                        <select
                          id="firstCallAcceptance"
                          value={firstCallAcceptance || 'agent'}
                          onChange={(e) => setFirstCallAcceptance(e.target.value || 'agent')}
                          className="form-control form-select"
                          style={iconInputStyle}
                        >
                          {firstCallAcceptanceOptions.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}
                  <div className="col-md-12">
                    <CountryCodeDirectionPicker
                      items={availableCcDirections}
                      selectedIds={selectedCcDirections}
                      onChange={setSelectedCcDirections}
                      label="Country Codes (Optional)"
                      placeholder="Select country codes"
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          <div>
            <Card style={cardStyle}>
              <CardContent style={{ padding: 20 }}>
                <div className="d-flex align-items-start gap-2 mb-4">
                  <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <FaFileAlt size={13} />
                  </span>
                  <div>
                    <p className="m-0 text-sm font-bold text-foreground">
                      Description <span className="ml-1 text-xs font-normal text-muted-foreground">(Optional)</span>
                    </p>
                    <p className="m-0 text-xs text-muted-foreground">Add a brief description about the agent.</p>
                  </div>
                </div>
                <textarea
                  id="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="form-control w-full"
                  placeholder="Enter description"
                  rows={4}
                  maxLength={500}
                  style={{ ...inputStyle, minHeight: 100, resize: 'vertical' }}
                />
                <div className="mt-1 text-right text-xs text-muted-foreground">
                  {String(description || '').length} / 500
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
        )}

        {isCallCentreAdmin && stepper.current === 2 && (
          <Card style={cardStyle} className="mb-3 mt-3">
            <CardContent style={{ padding: 20 }}>
              <AgentAccountSettingsSection
                access={access}
                selectedACL={selectedACL}
                setSelectedACL={setSelectedACL}
                accountType={accountType}
                setAccountType={setAccountType}
                expiryDate={expiryDate}
                setExpiryDate={setExpiryDate}
                parentAccountType={parentAccountType}
                parentExpiryDate={parentExpiryDate}
                labelStyle={labelStyle}
                inputStyle={inputStyle}
                iconInputStyle={iconInputStyle}
                inputWrapperStyle={inputWrapperStyle}
                inputIconStyle={inputIconStyle}
                requiredMark={requiredMark}
                disableExpiry={isDemoCompanyAgent}
              />
            </CardContent>
          </Card>
        )}

        <div className="mt-3 flex flex-wrap items-center justify-between gap-3 px-2 py-2">
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <FaLightbulb size={13} className="text-muted-foreground" />
            <span>
              Step{' '}
              <span className="font-semibold text-foreground">
                {stepper.current + 1}
              </span>{' '}
              of{' '}
              <span className="font-semibold text-foreground">
                {stepDescriptors.length}
              </span>{' '}
              · Fields marked with{' '}
              <span className="text-destructive">*</span> are required.
            </span>
          </div>
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="inline-flex h-10 min-w-[100px] items-center justify-center rounded-md border border-border/60 bg-card px-4 text-xs font-semibold text-foreground shadow-[3px_3px_6px_rgba(163,177,198,0.35),-3px_-3px_6px_rgba(255,255,255,0.9)] transition-colors hover:bg-accent hover:text-accent-foreground cursor-pointer"
            >
              Cancel
            </button>
            {!stepper.isFirst && (
              <button
                type="button"
                onClick={stepper.prev}
                className="inline-flex h-10 min-w-[100px] items-center justify-center gap-2 rounded-md border border-border/60 bg-card px-4 text-xs font-semibold text-foreground shadow-[3px_3px_6px_rgba(163,177,198,0.35),-3px_-3px_6px_rgba(255,255,255,0.9)] transition-colors hover:bg-accent hover:text-accent-foreground cursor-pointer"
              >
                <FaChevronLeft size={11} />
                Previous
              </button>
            )}
            {!stepper.isLast && (
              <button
                type="button"
                onClick={() => {
                  if (stepper.current === 0) {
                    const nameErr = getAgentNameFieldError(agentName, existingAgentNamesRef.current);
                    if (nameErr) {
                      setAgentNameError(nameErr);
                      toast.error(nameErr);
                      return;
                    }
                  }
                  stepper.next();
                }}
                className="inline-flex h-10 min-w-[100px] items-center justify-center gap-2 rounded-md border border-primary bg-primary px-4 text-xs font-bold text-primary-foreground shadow-[3px_3px_6px_rgba(163,177,198,0.4),-3px_-3px_6px_rgba(255,255,255,0.9)] transition-colors hover:bg-primary/90 cursor-pointer"
              >
                Next
                <FaChevronRight size={11} />
              </button>
            )}
            {stepper.isLast && (
              <button
                type="button"
                onClick={handleEditAgent}
                disabled={loading}
                className="inline-flex h-10 min-w-[124px] items-center justify-center gap-2 rounded-md border border-primary bg-primary px-4 text-xs font-bold text-primary-foreground shadow-[3px_3px_6px_rgba(163,177,198,0.4),-3px_-3px_6px_rgba(255,255,255,0.9)] transition-colors hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-60 cursor-pointer"
              >
                <FaPlusCircle size={14} />
                {loading ? 'Updating…' : 'Update Agent'}
              </button>
            )}
          </div>
        </div>
      </form>
      </div>
    </ScrollPage>
  );
}
